<template>
  <div
    ref="svgItem"
    class="svg-container"
    :style="computedStyle"
    :class="customClass"
    v-html="src ?? ''" />
</template>

<script setup lang="ts">
import { computed, nextTick, useTemplateRef, watch } from 'vue';
const props = withDefaults(defineProps<IBaseSvg>(), {
  src: '',
  alt: ''
});
const svgItem = useTemplateRef<HTMLDivElement>('svgItem');
export interface IBaseSvg {
  src?: string;
  alt?: string;
  customClass?: string;
  width?: string;
  height?: string;
}

const computedStyle = computed(() => {
  return {
    width: props.width + 'px' || '',
    height: props.height + 'px' || ''
  };
});
watch(
  () => props.src,
  (newSrc) => {
    if (newSrc) {
      nextTick(() => {
        const svgElement = svgItem.value?.firstChild as SVGElement;
        if (!svgElement) {
          return;
        }
        if (props.width) {
          svgElement.setAttribute('width', props.width);
        }
        if (props.height) {
          svgElement.setAttribute('height', props.height);
        }
      });
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.svg-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: max-content;
}
</style>
